import React, { useEffect, useState } from "react";
import PageHeader from "../../components/common/PageHeader";
import StatsCardGroup from "../../components/common/StatsCardGroup";
import BarAnalyticsChart from "../../components/vendors/BarAnalyticsChart";
import {
  CurrencyDollarIcon,
  CalendarIcon,
  StarIcon,
  UserGroupIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import {
  useVendorDashboardOverview,
  useVendorBookingTrend,
} from "../../custom-hooks/queries";
import { formatValue, trimFloatNumber } from "../../utils/HelperMethod";
import { useAuthStore } from "../../store/useAuthStore";

const Dashboard = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  // Fetch dashboard overview data
  const { data: overviewData, isLoading: isOverviewLoading } =
    useVendorDashboardOverview();

  const setVendorStatus = useAuthStore((state) => state.setVendorStatus);

  useEffect(() => {
    setVendorStatus(overviewData?.data?.vendor?.verificationStatus || "");
  }, [overviewData]);

  // Fetch booking trend data
  const { data: trendData, isLoading: isTrendLoading } =
    useVendorBookingTrend(selectedYear);

  // Format number for display

  // Stats data from API
  const dashboardCards = overviewData?.data?.dashboardCards || {};
  const vendor = overviewData?.data?.vendor || {};

  const user = useAuthStore.getState().user;

  const stats = [
    {
      icon: <CurrencyDollarIcon className="h-6 w-6" />,
      label: "Total Earning",
      value: formatValue(dashboardCards.totalEarnings, "currency"),
    },
    {
      icon: <CalendarIcon className="h-6 w-6" />,
      label: "Total Bookings",
      value: formatValue(dashboardCards.totalBookings, "count"),
    },
    {
      icon: <StarIcon className="h-6 w-6" />,
      label: "Average Rating",
      value: trimFloatNumber(dashboardCards?.averageRating) || "-",
    },
    {
      icon: <UserGroupIcon className="h-6 w-6" />,
      label: "Total Experiences",
      value: formatValue(dashboardCards.totalExperiences, "count"),
    },
    {
      icon: <ClockIcon className="h-6 w-6" />,
      label: "Upcoming Bookings",
      value: formatValue(dashboardCards.upcomingBookings, "count"),
    },
  ];

  // Chart data from API
  const chartData =
    trendData?.data?.monthly?.map((item) => ({
      month: item.month,
      value: item.earnings,
      bookings: item.bookings,
    })) || [];

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  return (
    <div className="px-4 py-1 sm:px-6 sm:py-1">
      <PageHeader
        title={`Welcome back, ${vendor.firstName || "User"}! 👋`}
        description="Here's what's happening with your experiences today"
      />

      <div className="mt-4 sm:mt-6">
        <StatsCardGroup stats={stats} isLoading={isOverviewLoading} />
      </div>

      <div className="mt-4 sm:mt-6">
        <BarAnalyticsChart
          data={chartData}
          showToggle={false}
          showFilters={false}
          showYearDropdown={true}
          heading="Booking Trend"
          onYearChange={handleYearChange}
          selectedYear={selectedYear}
          isLoading={isTrendLoading}
        />
      </div>
    </div>
  );
};

export default Dashboard;
